import React from 'react';

// Shared success/error banner for integration sync results.
//
// Every sync reports back the same way — an { error } on failure, or stats on
// success — so the container styling lives here and each caller supplies only
// its own success content. Workday passes a rich stats grid as children; the
// other integrations pass a one-line summary.
export default function SyncResultBanner({ result, children, style }) {
  if (!result) return null;

  const failed = Boolean(result.error);

  return (
    <div style={{
      padding: '10px 14px',
      borderRadius: 'var(--radius-sm)',
      fontSize: 14,
      background: failed ? 'var(--red-dim)' : 'var(--green-dim)',
      border: `1px solid ${failed ? 'var(--red)' : 'var(--green)'}`,
      ...style,
    }}>
      {failed
        ? <div style={{ color: 'var(--red)' }}>✗ {result.error}</div>
        : children
      }
    </div>
  );
}

// The counts most syncs report. Callers pass a subset, in display order.
export const SYNC_METRICS = {
  processed:  { key: 'records_processed', label: 'Processed' },
  created:    { key: 'records_created',   label: 'Created' },
  updated:    { key: 'records_updated',   label: 'Updated' },
  skipped:    { key: 'records_skipped',   label: 'Skipped' },
  errored:    { key: 'records_errored',   label: 'Errors', badgeWhenNonZero: 'badge-yellow' },
};
